export const statsData = [
  {
    id: 1,
    number: '500',
    label: 'Students Trained',
    icon: 'FaGraduationCap',
    color: '#4CAF50',
    suffix: '+'
  },
  {
    id: 2,
    number: '98',
    label: 'Satisfaction Rate',
    icon: 'FaSmile',
    color: '#FFC107',
    suffix: '%'
  },
  {
    id: 3,
    number: '50',
    label: 'Industry Experts',
    icon: 'FaUserTie',
    color: '#2196F3',
    suffix: '+'
  },
  {
    id: 4,
    number: '1000',
    label: 'Hours of Content',
    icon: 'FaClock',
    color: '#9C27B0',
    suffix: '+'
  }
];
